"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29],{

/***/ 3443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "About": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./src/components/elements/Headline/Headline.tsx
var Headline = __webpack_require__(6745);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/utils/mediaQueries.ts
var mediaQueries = __webpack_require__(5672);
;// CONCATENATED MODULE: ./src/components/elements/DescriptionList/DescriptionList.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    /* 88px are the max-width of the term column */\n    grid-template-columns: minmax(auto, 88px) 1fr;\n    grid-gap: var(--distance-static-s);\n\n    @media screen and (",
        ") {\n      /* 92px are the max-width of the term column */\n      grid-template-columns: minmax(auto, 92px) 1fr;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: var(--font-size-static-s);\n  line-height: var(--line-height-static-m);\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: var(--distance-static-xxs);\n\n  & ~ & {\n    margin-top: var(--distance-static-m);\n  }\n\n  @media screen and (",
        ") {\n    grid-template-columns: auto 1fr;\n    grid-gap: var(--distance-static-xs);\n\n    & ~ & {\n      margin-top: var(--distance-static-xxs);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: var(--font-weight-heavy);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var variants = {
    primary: (0,styled_components_browser_esm/* css */.iv)(_templateObject(), mediaQueries/* tabletPortrait */.ZI),
    secondary: null
};
var StyledDescriptionList = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-f6426d32-0"
})(_templateObject1(), function(param) {
    var $variant = param.$variant;
    return variants[$variant];
});
var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6426d32-1"
})(_templateObject2(), mediaQueries/* tabletPortrait */.ZI);
var StyledDescriptionTerm = styled_components_browser_esm/* default.dt.withConfig */.ZP.dt.withConfig({
    componentId: "sc-f6426d32-2"
})(_templateObject3());
var StyledDescriptionDetails = styled_components_browser_esm/* default.dd.withConfig */.ZP.dd.withConfig({
    componentId: "sc-f6426d32-3"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/components/elements/DescriptionList/DescriptionList.tsx



var DescriptionList = function(param) {
    var className = param.className, data = param.data, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescriptionList, {
        className: className,
        $variant: variant,
        children: variant === "primary" ? data.map(function(param) {
            var id = param.id, term = param.term, description = param.description;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescriptionTerm, {
                        children: term
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescriptionDetails, {
                        children: description
                    })
                ]
            }, id);
        }) : data.map(function(param) {
            var id = param.id, term = param.term, description = param.description;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescriptionTerm, {
                        children: term
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescriptionDetails, {
                        children: description
                    })
                ]
            }, id);
        })
    });
};

// EXTERNAL MODULE: ./src/components/modules/ExpandableCopy/ExpandableCopy.tsx + 1 modules
var ExpandableCopy = __webpack_require__(6288);
// EXTERNAL MODULE: ./src/components/modules/Wrapper/Wrapper.tsx + 1 modules
var Wrapper = __webpack_require__(8709);
;// CONCATENATED MODULE: ./src/components/modules/About/About.styled.ts

function About_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (",
        ") {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n  }\n"
    ]);
    About_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function About_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-dynamic-s);\n\n  @media screen and (",
        ") {\n    grid-column: 1 / span 7;\n  }\n"
    ]);
    About_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function About_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: var(--distance-dynamic-s);\n\n  @media screen and (",
        ") {\n    grid-column: 1 / span 7;\n  }\n"
    ]);
    About_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function About_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (",
        ") {\n    grid-column: 1 / span 7;\n  }\n"
    ]);
    About_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper.Wrapper).withConfig({
    componentId: "sc-1a0ee0d9-0"
})(About_styled_templateObject(), mediaQueries/* laptop */.PJ);
var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Headline/* Headline */.s).withConfig({
    componentId: "sc-1a0ee0d9-1"
})(About_styled_templateObject1(), mediaQueries/* laptop */.PJ);
var About_styled_StyledDescriptionList = (0,styled_components_browser_esm/* default */.ZP)(DescriptionList).withConfig({
    componentId: "sc-1a0ee0d9-2"
})(About_styled_templateObject2(), mediaQueries/* laptop */.PJ);
var StyledExpandableCopy = (0,styled_components_browser_esm/* default */.ZP)(ExpandableCopy/* ExpandableCopy */.T).withConfig({
    componentId: "sc-1a0ee0d9-3"
})(About_styled_templateObject3(), mediaQueries/* laptop */.PJ);

;// CONCATENATED MODULE: ./src/components/modules/About/About.tsx


var About = function(param) {
    var className = param.className, headline = param.headline, descriptionList = param.descriptionList, copy = param.copy, expandButtonLabels = param.expandButtonLabels;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        width: {
            laptop: "l",
            tabletLandscape: "m"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                forwardedAs: "h2",
                size: "h3",
                label: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About_styled_StyledDescriptionList, {
                data: descriptionList,
                variant: "secondary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExpandableCopy, {
                text: copy,
                buttonLabels: expandButtonLabels,
                lines: 5
            })
        ]
    });
};


/***/ })

}]);